import { router } from '../utils/router.util';
import { ToolbarComponent } from '../components/toolbar.component';
import { ROUTES } from '../constants/routes.constants';

export class HowItWorksPage {
  private container: HTMLElement;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  render(): void {
    this.container.innerHTML = this.buildHTML();
    this.attachEvents();
  }

  private buildHTML(): string {
    return `
      <div class="how-it-works-page">
        ${ToolbarComponent.render({
          title: 'Como funciona',
          showBackButton: true,
          showMenuButton: false,
          elevation: 2,
          logoAlign: 'left'
        })}
        <div class="how-it-works-content">
          <div class="how-it-works-section">
            <h2 class="how-it-works-title">Termo de Uso - Vivo Dados Patrocinados</h2>
            <p class="how-it-works-text">
              Antes de participar do serviço "Vivo Dados Patrocinados", o usuário deve ler o presente Termo de Uso. A adesão ao serviço implica no entendimento e na aceitação total das condições, regras e normas descritas neste Termo da Vivo.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Sobre o serviço</h3>
            <p class="how-it-works-text">
              O serviço "Vivo Dados Patrocinados" é um serviço gratuito de veiculação de ofertas de produtos, marcas e serviços por meio de vídeos, aplicativos para celular ou sites mobile. As ofertas respeitarão os limites de idade impostos pela Legislação Brasileira.
            </p>
            <p class="how-it-works-text">
              A Vivo reserva-se o direito de verificar a elegibilidade dos usuários para participação no serviço.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Navegação gratuita</h3>
            <p class="how-it-works-text">
              As peças publicitárias disponibilizadas através deste produto, tais como vídeos, banners e páginas de pesquisa, não terão seu tráfego de dados contabilizado contra o saldo de dados da linha do usuário.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Uso do serviço</h3>
            <p class="how-it-works-text">
              O serviço "Vivo Dados Patrocinados" é destinado exclusivamente para uso pessoal do usuário, não devendo ser utilizado para fins comerciais.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Responsabilidades</h3>
            <p class="how-it-works-text">
              Os componentes das ofertas do serviço "Vivo Dados Patrocinados" são fornecidos por parceiros da Vivo. A Vivo não se responsabiliza pelos serviços anunciados, incluindo, mas não se limitando, à sua precisão, relevância ou qualidade.
            </p>
            <p class="how-it-works-text">
              As condições e a concessão dos benefícios oferecidos são de inteira responsabilidade do parceiro anunciante, assim como a qualidade dos produtos e/ou serviços disponibilizados.
            </p>
            <p class="how-it-works-text">
              O usuário reconhece e concorda que a Vivo não é responsável pela disponibilidade de quaisquer sites de terceiros ou materiais anunciados através do "Vivo Dados Patrocinados", não endossando nem garantindo conteúdos, publicidades, produtos ou serviços neles contidos.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Alterações no serviço</h3>
            <p class="how-it-works-text">
              A Vivo reserva-se o direito de alterar, suspender ou encerrar o serviço "Vivo Dados Patrocinados", mediante aviso prévio aos usuários com antecedência mínima de 30 (trinta) dias, por meio de comunicado em site, e-mail, SMS ou outro canal físico ou eletrônico disponível.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Pacotes de dados</h3>
            <p class="how-it-works-text">
              Todos os pacotes de dados obtidos após a interação com campanhas publicitárias veiculadas pelo "Vivo Dados Patrocinados" serão entregues de forma gratuita, não havendo qualquer cobrança de saldo referente à ativação do pacote.
            </p>
            <p class="how-it-works-text">
              A quantidade de participações consecutivas em uma mesma campanha é definida pelo anunciante, em acordo com a Vivo.
            </p>
            <p class="how-it-works-text">
              Os pacotes de dados podem levar até 24 horas, a partir da conclusão da interação com a campanha publicitária, para serem creditados na linha participante. Em caso de dúvidas, o usuário deve ligar para 1058.
            </p>
            <p class="how-it-works-text">
              Todo pacote patrocinado possui validade informada no SMS de confirmação, podendo variar do dia da contratação + 24 horas até 30 dias. A quantidade de dados creditados como bônus varia conforme a campanha veiculada, e os pacotes têm prioridade de consumo sobre os demais pacotes contratados.
            </p>
          </div>

          <div class="how-it-works-section">
            <h3 class="how-it-works-subtitle">Elegibilidade</h3>
            <p class="how-it-works-text">
              São elegíveis para participar deste tipo de ação clientes com linha Vivo nas modalidades Pré-pago, Controle e Pós-pago, pessoa física, em smartphone. Critérios adicionais de controle e frequência de exibição das campanhas são definidos pelo anunciante.
            </p>
          </div>
        </div>
      </div>
    `;
  }

  private attachEvents(): void {
    ToolbarComponent.attachEvents(this.container, {
      showBackButton: true,
      backButtonAction: () => {
        router.navigate(ROUTES.HOME);
      }
    });
  }
}
